import React from 'react';

export const usePushEvents = events => {
    React.useEffect(() => {
        if (window.dataLayer) {
            events.forEach(event => {
                window.dataLayer.push({ event });
            });
        }
    }, [events]);
};
